declare const ajax: {
    url: string
    nonce: string
}

let C = {
    sectorLink: 'filters__sectorlink',
    sectorInputs: 'filters__fieldset-sectors input',
    typeInputs: 'filters__fieldset-types input',
    spaceInputs: 'filters__fieldset-spaces input',
    link: 'filters__link',
    pageLink: 'pagination__arrow',
    pagination: 'projects-pagination',
    pageLinkDisabled: 'pagination__arrow--disabled',
    pageLinkPrev: 'pagination--prev',
    pageLinkNext: 'pagination--next',
}

class Filters {
    content: HTMLElement
    list: HTMLElement
    form: HTMLFormElement
    sectorInputs: HTMLElement[]
    typeInputs: HTMLElement[]
    spaceInputs: HTMLElement[]
    currentSector: string = ''
    currentTypes: string[] = []
    currentSpaces: string[] = []
    currentPage: number = 1
    pagination: HTMLElement
    paginationPrev: HTMLElement
    paginationNext: HTMLElement

    constructor(
        content: HTMLElement,
        form: HTMLFormElement,
        pagination: HTMLElement
    ) {
        this.content = content
        this.form = form
        this.sectorInputs = Array.from(
            this.form.querySelectorAll(`.${C.sectorInputs}`)
        )
        this.typeInputs = Array.from(
            this.form.querySelectorAll(`.${C.typeInputs}`)
        )
        this.spaceInputs = Array.from(
            this.form.querySelectorAll(`.${C.spaceInputs}`)
        )
        this.pagination = pagination
        this.paginationPrev = pagination.querySelector(`.${C.pageLinkPrev}`)
        this.paginationNext = pagination.querySelector(`.${C.pageLinkNext}`)

        this.getFormData()

        this.currentPage = parseInt(this.form.dataset.paged ?? '1')
        // this.content.addEventListener('click', this.clickEvent)
        this.pagination.addEventListener('click', this.clickEvent)
        this.form.addEventListener('change', this.inputEvent)
    }

    getFormData = () => {
        let data = new FormData(this.form)

        this.currentTypes = data.getAll('project-type') as string[]
        this.currentSpaces = data.getAll('spaces') as string[]
        this.currentSector = (data.get('sectors') as string) || ''
        this.currentPage = 1
    }

    inputEvent = (e: Event) => {
        this.getFormData()
        this.doFetch()
    }

    clickEvent = (e: MouseEvent) => {
        let target = e.target as HTMLElement
        let link = target.closest(`.${C.pageLink}`) as HTMLElement

        if (link && !link.classList.contains(C.pageLinkDisabled)) {
            e.preventDefault()
            if (link.classList.contains('pagination--next')) {
                this.currentPage++
            } else {
                this.currentPage--
            }
            this.doFetch()
        }
    }

    setPagination = (hasPrev: boolean, hasNext: boolean) => {
        if (hasPrev) {
            this.paginationPrev.classList.remove(C.pageLinkDisabled)
            this.paginationPrev.setAttribute('aria-label', 'Previous Page')
        } else {
            this.paginationPrev.classList.add(C.pageLinkDisabled)
            this.paginationPrev.setAttribute('aria-label', 'No Previous Page')
        }

        if (hasNext) {
            this.paginationNext.classList.remove(C.pageLinkDisabled)
            this.paginationNext.setAttribute('aria-label', 'Next Page')
        } else {
            this.paginationNext.classList.add(C.pageLinkDisabled)
            this.paginationNext.setAttribute('aria-label', 'No Next Page')
        }
    }

    doFetch = async () => {
        const data = new FormData()
        data.append('action', 'projects_filter')
        data.append('nonce', ajax.nonce)
        data.append('paged', this.currentPage.toString())
        if (this.currentSector.length > 0)
            data.append('sector', this.currentSector)
        if (this.currentSpaces.length > 0)
            data.append('spaces', this.currentSpaces.join('+'))
        if (this.currentTypes.length > 0)
            data.append('project-types', this.currentTypes.join('+'))

        await fetch(ajax.url, {
            method: 'POST',
            body: data,
        })
            .then((res) => res.text())
            .then((res) => {
                let { content, has_prev, has_next } = JSON.parse(res)
                this.content.innerHTML = content
                this.setPagination(has_prev, has_next)
            })
            .catch((err) => {
                console.log(err)
            })
    }
}

let filters = document.querySelector('form.project-filters')
let content = document.querySelector('.project-list')
let pagination = document.querySelector(`.${C.pagination}`)

if (filters && content) {
    let filterstuff = new Filters(
        content as HTMLElement,
        filters as HTMLFormElement,
        pagination as HTMLElement
    )
    // @ts-ignore
    window.filters = filterstuff
}
